import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Smartphone, Laptop, Monitor } from 'lucide-react';
import { brands } from '../../data/mock';

const BrandsSection = () => {
  const getIcon = (brandId) => {
    switch(brandId) {
      case 'macbook':
      case 'notebook':
        return <Laptop size={40} />;
      default:
        return <Smartphone size={40} />;
    }
  };

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2B3990] mb-4">
            Assistência Técnica Especializada
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Atendemos as principais marcas do mercado com técnicos especializados e peças de qualidade.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {brands.map((brand) => (
            <Link 
              key={brand.id}
              to={`/${brand.slug}`}
              className="group block"
            >
              <div className="p-6 bg-gray-50 rounded-2xl hover:bg-[#2B3990] transition-all duration-300 hover:shadow-xl">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div className="w-16 h-16 bg-white rounded-xl flex items-center justify-center shadow-sm group-hover:bg-[#8DC63F] transition-colors">
                      <span className="text-[#2B3990] group-hover:text-white transition-colors">
                        {getIcon(brand.id)}
                      </span>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-[#2B3990] group-hover:text-white transition-colors">
                        {brand.name}
                      </h3>
                      <p className="text-sm text-gray-500 group-hover:text-gray-200 transition-colors">
                        Assistência Técnica
                      </p>
                    </div>
                  </div>
                  <ChevronRight size={24} className="text-gray-400 group-hover:text-[#8DC63F] transition-colors" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandsSection;